import React, { useEffect, useState } from 'react';
import StepButton from '../../common/StepButton';
import { GetDiscountCode } from '../../redux/actions/getDiscount/getDiscount';
import CustomModal from '../../modal/CustomModal';
import TextInput from '../../common/TextInput';
import VerticalStack from '../../common/wrapper/VerticalStack';

const DiscountModal = ({ isOpen, setIsOpen, clinicId }) => {
    const [discount, setDiscount] = useState('');
    const { initDiscount, discountQueryData } = GetDiscountCode();

    const handleDiscountCode = () => {
        initDiscount({
            clinicId: clinicId,
            couponCode: discount,
        });
    };
    useEffect(() => {
        if (discountQueryData?.data?.getDiscount.success) {
            setDiscount('');
            setIsOpen(false);
        }
    }, [discountQueryData?.data, discountQueryData]);

    return (
        <CustomModal
            modaltitle="Add discount code"
            modalOpen={isOpen}
            type="common-width"
            setModalOpen={setIsOpen}
            modalBody={
                <VerticalStack className="mt-3">
                    <TextInput
                        label="Discount code"
                        name="discount"
                        value={discount}
                        onChange={(e) => setDiscount(e.target.value)}
                        placeholder="Discount code"
                    />
                    <StepButton
                        disabled={!discount.length}
                        blue={true}
                        isLoading={discountQueryData?.loading}
                        label={'Save'}
                        onClick={() => handleDiscountCode()}
                    />
                </VerticalStack>
            }
        />
    );
};

export default DiscountModal;
